/**
 * Lien d'invitation d'une salle CONSTRUIT DEPUIS `apps/tutor` — même origine
 * que soi-même (`/invite/:token`), contrairement à `apps/app` qui construit
 * vers `tutor.jeraisonne.fr` (cf. `apps/app/src/lib/visio/tutor-url.ts`).
 */
export function buildSameOriginInviteUrl(token: string): string {
  return `${window.location.origin}/invite/${token}`;
}
